import { Injectable } from '@angular/core';
import type { LogsLastUpdatedRange, LogsShipEntry } from './logs.models';

/** Snapshot of Logs page UI state preserved when opening log assessment. */
export type LogsPageSnapshot = {
  ships: readonly LogsShipEntry[];
  shipSearchQuery: string;
  lastUpdatedRange: LogsLastUpdatedRange | null;
  expandedShipIds: readonly string[];
  scrollY: number;
  /** Ship accordion row to scroll into view after Back to Logs. */
  anchorShipKey: string | null;
};

@Injectable({ providedIn: 'root' })
export class LogsPageStateService {
  private snapshot: LogsPageSnapshot | null = null;
  private scrollRestorePending = false;

  saveSnapshot(snapshot: LogsPageSnapshot): void {
    this.snapshot = {
      ships: [...snapshot.ships],
      shipSearchQuery: snapshot.shipSearchQuery,
      lastUpdatedRange: snapshot.lastUpdatedRange
        ? { start: new Date(snapshot.lastUpdatedRange.start), end: new Date(snapshot.lastUpdatedRange.end) }
        : null,
      expandedShipIds: [...snapshot.expandedShipIds],
      scrollY: snapshot.scrollY,
      anchorShipKey: snapshot.anchorShipKey,
    };
    this.scrollRestorePending = true;
  }

  consumeSnapshot(): LogsPageSnapshot | null {
    const snap = this.snapshot;
    this.snapshot = null;
    return snap;
  }

  discardSnapshot(): void {
    this.snapshot = null;
    this.scrollRestorePending = false;
  }

  /** True while returning from log assessment — skip global scroll-to-top. */
  isScrollRestorePending(): boolean {
    return this.scrollRestorePending;
  }

  clearScrollRestorePending(): void {
    this.scrollRestorePending = false;
  }
}
